/**
 * Firebase Error Translator
 * Translates common Firebase Auth error codes to user-friendly Arabic messages.
 */

export const translateFirebaseError = (code) => {
  switch (code) {
    case 'auth/email-already-in-use':
      return 'هذا البريد الإلكتروني مستخدم بالفعل من قبل حساب آخر.';
    case 'auth/invalid-email':
      return 'البريد الإلكتروني غير صحيح.';
    case 'auth/operation-not-allowed':
      return 'تسجيل الدخول بالبريد الإلكتروني وكلمة المرور غير مفعل.';
    case 'auth/weak-password':
      return 'كلمة المرور ضعيفة جداً، يجب أن تكون 6 أحرف على الأقل.';
    case 'auth/user-disabled':
      return 'هذا الحساب معطل حالياً.';
    case 'auth/user-not-found':
      return 'لا يوجد حساب مسجل بهذا البريد الإلكتروني.';
    case 'auth/wrong-password':
      return 'كلمة المرور غير صحيحة.';
    case 'auth/invalid-credential':
      return 'بيانات الاعتماد غير صحيحة أو انتهت صلاحيتها.';
    case 'auth/too-many-requests':
      return 'تم إرسال الكثير من الطلبات في وقت قصير. يرجى المحاولة لاحقاً.';
    case 'auth/requires-recent-login':
      return 'يرجى تسجيل الدخول مرة أخرى لتنفيذ هذا الإجراء الحساس.';
    case 'auth/network-request-failed':
      return 'فشل الاتصال بالشبكة. يرجى التحقق من اتصالك بالإنترنت.';
    case 'auth/popup-closed-by-user':
      return 'تم إغلاق النافذة المنبثقة قبل اكتمال العملية.';
    default:
      return 'حدث خطأ غير متوقع. يرجى المحاولة لاحقاً.';
  }
};
